import { useMemo, useState, useRef, useEffect } from 'react';
import MobxWrap from '@/components/MobxWrap';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { ClassNames, isEmpty, toggleGlobalScroll } from '@/utils';
import ossImgCompress from '@/utils/ossImgCompress';
import ReactDOMServer from 'react-dom/server';
import ProudctPoint from '@/utils/Tracker/_product';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import ProductMasterDataConfig from './data.config';
import 'photoswipe/dist/photoswipe.css';
import '@splidejs/react-splide/css';
import { getTag } from '@/pages/product/config/DisplayTag.config';
import SocialMediaLogo from '../SocialMediaLogo';

const EMPTY_IMG_URL = 'https://static.insta360.com/assets/storage/20191218/f2a97117d5c7b21d3e9f9b28dad343f5/1.png';
const SHOW_THUMB_MAX = 7; // 最多展示几张缩略图

const EXPOSE_VIDEO = new Map([]);
const EXPOSE_IMAGE = new Map([]);
let isOpen = false;

const CLOSE_ICON = (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter0_b_9400_51757)'>
      <rect width='56' height='56' rx='28' fill='black' fillOpacity='0' />
      <path
        d='M28.0008 29.4008L21.0008 36.4008C20.8008 36.6008 20.5674 36.7008 20.3008 36.7008C20.0341 36.7008 19.8008 36.6008 19.6008 36.4008C19.4008 36.2008 19.3008 35.9674 19.3008 35.7008C19.3008 35.4341 19.4008 35.2008 19.6008 35.0008L26.6008 28.0008L19.6008 21.0008C19.4008 20.8008 19.3008 20.5674 19.3008 20.3008C19.3008 20.0341 19.4008 19.8008 19.6008 19.6008C19.8008 19.4008 20.0341 19.3008 20.3008 19.3008C20.5674 19.3008 20.8008 19.4008 21.0008 19.6008L28.0008 26.6008L35.0008 19.6008C35.2008 19.4008 35.4341 19.3008 35.7008 19.3008C35.9674 19.3008 36.2008 19.4008 36.4008 19.6008C36.6008 19.8008 36.7008 20.0341 36.7008 20.3008C36.7008 20.5674 36.6008 20.8008 36.4008 21.0008L29.4008 28.0008L36.4008 35.0008C36.6008 35.2008 36.7008 35.4341 36.7008 35.7008C36.7008 35.9674 36.6008 36.2008 36.4008 36.4008C36.2008 36.6008 35.9674 36.7008 35.7008 36.7008C35.4341 36.7008 35.2008 36.6008 35.0008 36.4008L28.0008 29.4008Z'
        fill='#262629'
      />
    </g>
    <defs>
      <filter
        id='filter0_b_9400_51757'
        x='-10'
        y='-10'
        width='76'
        height='76'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feGaussianBlur in='BackgroundImageFix' stdDeviation='5' />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_9400_51757' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_9400_51757' result='shape' />
      </filter>
    </defs>
  </svg>
);

const L_ARROW = (
  <svg
    className={styles.b_arrow}
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z'
      fill='black'
      fillOpacity='0.1'
    />
    <path
      d='M30.334 35L23.334 28L30.334 21'
      stroke='white'
      strokeWidth='2.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const R_ARROW = (
  <svg
    className={styles.b_arrow}
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56Z'
      fill='black'
      fillOpacity='0.1'
    />
    <path
      d='M25.666 35L32.666 28L25.666 21'
      stroke='white'
      strokeWidth='2.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ProductMaster = MobxWrap(['area', 'product', 'app', 'abtest'], (props) => {
  const {
    product: {
      productDetail,
      curSelectCommodity,
      curSelectCommodityId,
      productDetail: { url_key, id },
    },
    app: { webp, isMobile, urlQuery },
    area: {
      LANG,
      country: { X_Language, code },
    },
    abtest: { isTargetingResult },
  } = props;

  const [activeIndex, setActiveIndex] = useState(0);
  const [curstate, setCurState] = useState('img');
  const splideRef = useRef(null);
  const videoSplideRef = useRef(null);
  const smallVideoSplideRef = useRef(null);
  // one2 产品页展示场景图，主图默认展示第二张
  const showOnex2ProductScene = useMemo(() => {
    return (
      ProductMasterDataConfig.onex2ProductSceneCommodities.has(curSelectCommodityId) &&
      ProductMasterDataConfig.onex2ProductSceneCountry.has(code)
    );
  }, [code, curSelectCommodityId]);

  // GO3S 产品页展示场景图，主图默认展示第二张
  const showGO3SProductScene = useMemo(() => {
    if (ProductMasterDataConfig.GO3SProductSceneCommodities.has(curSelectCommodityId) && X_Language !== 'zh_cn') {
      return true;
    }
    return false;
  }, [curSelectCommodityId, X_Language]);

  /**
   * Flow 产品页展示场景图，主图默认展示第二张(非中国大陆地区)
   * tb卡：https://www.teambition.com/task/67d8e0739aa0c90b3b362c28
   * 运营：陈子莹
   */
  const showFlowProductScene = id === 22 && X_Language !== 'zh_cn';

  // snowkitsale期间滑雪套餐链接进入
  const showSnowkitScene = useMemo(() => {
    const { time, enabledCmds } = ProductMasterDataConfig.getSnowKitSceneConfig(code);
    const now = new Date().getTime();
    return (
      now > time[0] && now < time[1] && enabledCmds.includes(urlQuery.c) && urlQuery.c === String(curSelectCommodityId)
    );
  }, [code, urlQuery, curSelectCommodityId]);

  /**
   * @description 初始化主图素材
   *  showMoreDot 是否展示折叠按钮
   *  规则：如果主图中存在一张urlL字段没有数据，则这个套餐所有图片都不能放大
   */
  const masterList = useMemo(() => {
    if (!curSelectCommodity.displays) {
      curSelectCommodity.displays = [];
    }

    // 如果素材为空，则添加一个默认素材
    if (curSelectCommodity.displays?.length === 0) {
      curSelectCommodity.displays.push({
        id: 1,
        url: EMPTY_IMG_URL,
        urlL: '',
        url_m: EMPTY_IMG_URL,
        url_s: EMPTY_IMG_URL,
      });
    }

    const isCanZoom = curSelectCommodity.displays?.every((item) => !isEmpty(item?.urlL));

    const displayResources = curSelectCommodity.displays?.map((item) => ({
      ...item,
      url: ossImgCompress(item.url, { webp }),
      urlL: ossImgCompress(item.urlL, { webp }),
      url_m: ossImgCompress(item.url_m, { webp }),
      url_s: ossImgCompress(item.url_s, { webp, width: 124, height: 124 }),
    }));

    if (isTargetingResult('Insta360_Ace_Pro_2_product_image_text', 'test') && X_Language === 'en_us') {
      ProductMasterDataConfig.hanldeAP2ABT({ cid: curSelectCommodityId, displayResources, webp });
    }

    if (isTargetingResult('F2P-SP-image-test', 'Original') && id === 32) {
      displayResources.length >= 9 && displayResources.splice(1, 8);
    }

    // 是三个自拍杆套餐之一
    const isSelfieStickCommodity = [2141, 1344, 2601].includes(curSelectCommodity.id);
    // 组别映射
    const groupMap = {
      'Image_text_intergrated': 'groupOne',
      'Image_above_text_below': 'groupTwo',
    };

    // get 当前组别
    const group = Object.entries(groupMap).find(
      ([key]) => isSelfieStickCommodity && X_Language === 'en_us' && isTargetingResult('selfiestick_main_picture', key)
    );

    if (group) {
      const resources = ProductMasterDataConfig.hanldeSelfieStickABT(
        curSelectCommodity.id,
        displayResources[0],
        group[1],
        webp
      );
      return assembleList(resources, isCanZoom);
    }

    return assembleList(displayResources, isCanZoom);
  }, [curSelectCommodityId, curSelectCommodity.displays, webp]);

  function assembleList(displayResources, isCanZoom) {
    // 大于SHOW_THUMB_MAX则显示折叠按钮
    if (displayResources.length > SHOW_THUMB_MAX) {
      return {
        showMoreDot: true,
        masterList: displayResources,
        thumbList: displayResources.slice(0, SHOW_THUMB_MAX - 1),
        remainThumbList: displayResources.slice(SHOW_THUMB_MAX - 1),
        isCanZoom,
      };
    } else {
      return {
        showMoreDot: false,
        masterList: displayResources,
        thumbList: displayResources,
        remainThumbList: [],
        isCanZoom,
      };
    }
  }

  /**
   * @description 初始化视频素材
   * 过滤出当前套餐的主视频
   */
  const mainVideoList = useMemo(() => {
    if (isEmpty(productDetail?.productMainVideoVoList)) return [];
    return productDetail?.productMainVideoVoList
      .filter((item) => {
        if (!item.commodityCondition) return true;
        return item?.commodityList?.some((id) => id === curSelectCommodityId);
      })
      .map((o) => {
        o.coverLink = ossImgCompress(o.coverLink, { webp });
        o.coverPreviewLinkPc = ossImgCompress(o.coverPreviewLinkPc, { webp });
        return o;
      });
  }, [curSelectCommodityId, productDetail?.productMainVideoVoList]);

  const loadVideo = (ele) => {
    if (!ele || !ele?.dataset.mastersrc) return;
    ele.src = ele.dataset.mastersrc;
  };

  /**
   * @description 主视频操作节点时的视频元素处理
   * @param {String} type 操作类型
   * 类型种类有：
   * 1. video_register_event 视频元素注册事件
   * 2. video_move 视频轮播切换时
   * 3. video_stop_all 停止所有视频播放 ——点击图片缩略图时
   * 4. video_play 点击主视频播放
   */
  const handleVideo = (type, params) => {
    if (!type || !videoSplideRef.current) return;
    switch (type) {
      // 视频元素注册事件
      case 'video_register_event':
        const videoList = document.querySelectorAll('#mainVideo');
        videoSplideRef.current.videoEle = [...videoList] ?? [];
        videoSplideRef.current.videoEle.forEach((videoItem) => {
          videoItem.addEventListener('ended', () => {
            videoItem.currentTime = 0;
            ProudctPoint.productPageImages({
              action: 'video_end',
              data: {
                ...curSelectCommodity,
                videoInnerName: videoItem?.dataset?.innername,
                url_key,
              },
            });
          });

          videoItem.addEventListener('loadeddata', () => {
            videoItem.play();
          });

          videoItem.addEventListener('play', () => {
            videoItem.parentNode.dataset.playing = true;
            ProudctPoint.productPageImages({
              action: 'video_play',
              data: {
                ...curSelectCommodity,
                videoInnerName: videoItem?.dataset?.innername,
                url_key,
              },
            });
          });
        });
        break;
      // 视频轮播切换时
      case 'video_move':
        const { newIndex, preIndex } = params;
        videoSplideRef.current.videoEle?.[preIndex]?.pause();
        videoSplideRef.current.videoEle[preIndex].currentTime = 0;
        videoSplideRef.current.videoEle[preIndex].src = '';
        videoSplideRef.current.videoEle[preIndex].load();
        videoSplideRef.current.videoEle[preIndex].parentNode.dataset.clickplay = false;
        videoSplideRef.current.videoEle[preIndex].parentNode.dataset.playing = false;
        if (!EXPOSE_VIDEO.has(mainVideoList[newIndex]?.id)) {
          ProudctPoint.productPageImages({
            action: 'video_expose',
            data: {
              ...curSelectCommodity,
              videoInnerName: mainVideoList[newIndex]?.videoInnerName,
              url_key,
            },
          });
          EXPOSE_VIDEO.set(mainVideoList[newIndex]?.id, true);
        }
        break;
      // 停止所有视频播放 ——点击图片缩略图时
      case 'video_stop_all':
        videoSplideRef.current.videoEle.forEach((item) => {
          item.pause();
          item.currentTime = 0;
          item.src = '';
          item.load();
          item.parentNode.dataset.clickplay = false;
          item.parentNode.dataset.playing = false;
        });
        break;
      // 点击视频播放
      case 'video_play':
        const { curIndex } = params;
        videoSplideRef.current.videoEle[curIndex].parentNode.dataset.clickplay = true;
        loadVideo(videoSplideRef.current.videoEle[curIndex]);
        videoSplideRef.current.videoEle[curIndex].play();
        break;
    }
  };

  /**
   * @description 预览小视频操作节点时的视频元素处理
   * @param {String} type 操作类型
   * 类型种类有：
   * 1. smallVideo_register_event 预览小视频元素注册事件
   * 2. samllVideo_init 预览小视频恢复成初始状态 ——点击图片缩略图时
   * 3. smallVideo_play_mainVideo 视频模式时
   * 4. smallVideo_move 预览小视频轮播时
   */
  const handleSmallVideo = (type, params) => {
    if (!type || !smallVideoSplideRef.current) return;
    switch (type) {
      case 'smallVideo_register_event':
        const smallVideoList = document.querySelectorAll('#smallVideo');
        if (smallVideoSplideRef.current) {
          smallVideoSplideRef.current.videoEle = [...smallVideoList] ?? [];
          smallVideoSplideRef.current.videoEle.forEach((videoItem) => {
            videoItem.addEventListener('ended', () => {
              if (smallVideoSplideRef.current.videoEle?.length === 1) {
                videoItem.currentTime = 0;
                videoItem.play();
              } else smallVideoSplideRef.current?.splide?.go('>');
            });
          });
          // 播放第一个预览视频
          loadVideo(smallVideoSplideRef.current.videoEle?.[0]);
          smallVideoSplideRef.current.videoEle?.[0]?.play();
        }
        break;
      case 'samllVideo_init':
        smallVideoSplideRef.current.splide.go(0);
        loadVideo(smallVideoSplideRef.current?.videoEle?.[0]);
        smallVideoSplideRef.current?.videoEle?.[0]?.play();
        break;
      case 'smallVideo_play_mainVideo':
        smallVideoSplideRef.current.splide.go(0);
        smallVideoSplideRef.current.videoEle.forEach((item) => {
          item.pause();
          item.currentTime = 0;
          item.load();
        });
        break;
      case 'smallVideo_move':
        const { preIndex, newIndex } = params;
        smallVideoSplideRef.current.videoEle?.[preIndex]?.pause();
        smallVideoSplideRef.current.videoEle[preIndex].currentTime = 0;
        loadVideo(smallVideoSplideRef.current.videoEle?.[newIndex]);
        smallVideoSplideRef.current.videoEle?.[newIndex]?.play();
        break;
    }
  };

  // 切换套餐的视频部分的事件处理
  useEffect(() => {
    handleVideo('video_register_event');
    handleSmallVideo('smallVideo_register_event');
  }, [curSelectCommodity]);

  // 切换套餐的重置处理
  useEffect(() => {
    let index = 0;

    // X2 - 2024.1.3之前默认展示第二张折扣图
    const isX2InCampaign = productDetail.id === 13 && new Date().getTime() <= 1735891200000;
    const isRSTwinStandard = curSelectCommodityId === 1742;
    if (isX2InCampaign || isRSTwinStandard) index = 1;

    // 清空之前套餐的埋点记录
    EXPOSE_IMAGE.clear();
    EXPOSE_IMAGE.set(index, true);
    EXPOSE_VIDEO.clear();

    ProudctPoint.productPageImages({
      action: 'expose_image',
      data: {
        ...curSelectCommodity,
        url_key,
        imageIndex: 1,
      },
    });

    /**
     * 2025.3.7 onex2默认展示第二张主图
     * 2024.12.19 添加GO3S场景图后，GO3S默认展示第二张主图
     * snowkitsale期间滑雪套餐链接（c=2999/3000/3010/3011）进入也默认展示第二张主图
     */
    if (
      (showOnex2ProductScene || showGO3SProductScene || showSnowkitScene || showFlowProductScene) &&
      masterList.masterList.length > 1
    ) {
      setCurState('img');
      splideRef.current.splide.go(1);
      videoSplideRef.current.splide.go(0);
      setActiveIndex(1);
      const preLoadImg = new Image();
      preLoadImg.src = masterList.masterList[1]?.urlL;

      return;
    }

    // 切换套餐则初始化图片模式并滚动到第一张图
    setCurState('img');
    splideRef.current.splide.go(index);
    videoSplideRef.current.splide.go(index);
    setActiveIndex(index);

    // 预先加载第一张大图
    const preLoadImg = new Image();
    preLoadImg.src = masterList.masterList[0]?.urlL;
  }, [curSelectCommodity, masterList.masterList, showGO3SProductScene, showSnowkitScene]);

  /**
   * @description 预览视频按钮的文案
   * 规则：https://arashivision.feishu.cn/wiki/Tq3iww72Uii4OHk1nJWcNt7nnGe?from=from_lark_group_search
   */
  const smallVideoText = useMemo(() => {
    let text = [];

    if (mainVideoList.length === 1) text = [LANG['productNew.Display.video']];
    else {
      if (curstate === 'img') {
        switch (X_Language) {
          case 'ko_kr':
            text = [LANG['productNew.Display.videos'], `(${mainVideoList.length})`];
            break;
          case 'zh_cn':
          case 'zh_tw':
          case 'ja_jp':
            text = [LANG['productNew.Display.videos'], ` (${mainVideoList.length})`];
            break;
          default:
            text = [mainVideoList?.length, ` ${LANG['productNew.Display.videos']}`];
        }
      } else {
        switch (X_Language) {
          case 'en_us':
          case 'de_de':
          case 'es_es':
            text = [`${activeIndex + 1}/${mainVideoList?.length} `, LANG['productNew.Display.videos']];
            break;
          case 'fr_fr':
            text = [LANG['productNew.Display.video'], ` ${activeIndex + 1}/${mainVideoList?.length}`];
            break;
          case 'ja_jp':
          case 'zh_cn':
          case 'zh_tw':
            text = [LANG['productNew.Display.videos'], ` (${activeIndex + 1}/${mainVideoList?.length})`];
            break;
          case 'ko_kr':
            text = [LANG['productNew.Display.videos'], `(${activeIndex + 1}/${mainVideoList?.length})`];
            break;
          default:
            text = [LANG['productNew.Display.videos'], ` ${activeIndex + 1}/${mainVideoList?.length}`];
        }
      }
    }

    return text.join('');
  }, [LANG, X_Language, activeIndex, curstate, mainVideoList.length]);

  /**
   * @description 折叠按钮的文案——当主图数量大于SHOW_THUMB_MAX时才有
   */
  const samllMasterText = useMemo(() => {
    if (activeIndex > SHOW_THUMB_MAX - 1) return `+${masterList.masterList?.length - activeIndex}`;
    else return `+${masterList.masterList?.length - masterList.thumbList.length}`;
  }, [activeIndex, masterList.masterList?.length, masterList.thumbList.length]);

  /**
   * @description 是否要显示箭头按钮
   */
  const showArrow = useMemo(() => {
    if (curstate === 'img') return masterList?.masterList?.length > 1;
    else return mainVideoList?.length > 1;
  }, [curstate, mainVideoList?.length, masterList?.masterList?.length]);

  /**
   * @description 是否要显示缩略图按钮
   */
  const showThumb = useMemo(() => {
    return (
      (mainVideoList?.length > 0 && masterList.thumbList?.length > 0) ||
      (mainVideoList?.length === 0 && masterList.thumbList?.length > 1)
    );
  }, [mainVideoList?.length, masterList.thumbList?.length]);

  /**
   * @description 是否要显示社媒logo
   * —— 非png格式主图则不显示社媒logo
   */
  const showMediaLogo = useMemo(
    () => curstate !== 'video' && /.png/g.test(masterList?.masterList?.[activeIndex]?.url),
    [activeIndex, curstate, masterList.masterList]
  );

  /**
   * @description 是否缩放产品主图
   * —— 获取(多个)奖章配置并判断是否需要缩小产品主图
   */
  const scaleProductMaster = useMemo(
    () =>
      getTag({
        pid: productDetail.id,
        cid: curSelectCommodityId,
        country: props.area.country,
        isMobile,
      }).some((item) => item?.scaleProductMaster),
    [props.area.country, curSelectCommodityId, isMobile, productDetail.id]
  );

  return (
    <section className={styles.ProductMaster} key={curSelectCommodityId}>
      <div className={styles.container} data-type={curstate}>
        <div style={{ opacity: showMediaLogo ? 1 : 0 }} className={styles.mediaLogoContainer}>
          <SocialMediaLogo />
        </div>
        {showArrow && (
          <div
            className={ClassNames([styles.arrow, styles.arrowL])}
            onClick={() => {
              ProudctPoint.productPageImages({
                action: 'click_left',
                data: curSelectCommodity,
              });
              if (curstate === 'video') {
                videoSplideRef.current.splide.go('<');
              } else {
                splideRef.current.splide.go('<');
              }
            }}
          >
            <svg
              className={styles.arrSvg}
              width='49'
              height='48'
              viewBox='0 0 49 48'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clipPath='url(#clip0_9392_51685)'>
                <path
                  className={styles.arrPath}
                  d='M24.0723 48C37.3271 48 48.0723 37.2548 48.0723 24C48.0723 10.7452 37.3271 0 24.0723 0C10.8174 0 0.0722656 10.7452 0.0722656 24C0.0722656 37.2548 10.8174 48 24.0723 48Z'
                  fill='black'
                  // fillOpacity='0.1'
                />
                <path
                  d='M25.0723 29L20.0723 24L25.0723 19'
                  stroke='white'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  fillOpacity={1}
                />
              </g>
              <defs>
                <clipPath id='clip0_9392_51685'>
                  <rect width='48' height='48' fill='white' transform='translate(0.0722656)' />
                </clipPath>
              </defs>
            </svg>
          </div>
        )}
        {showArrow && (
          <div
            className={ClassNames([styles.arrow, styles.arrowR])}
            onClick={() => {
              ProudctPoint.productPageImages({
                action: 'click_right',
                data: curSelectCommodity,
              });
              if (curstate === 'video') {
                videoSplideRef.current?.splide.go('>');
              } else {
                splideRef.current?.splide.go('>');
              }
            }}
          >
            <svg
              className={styles.arrSvg}
              width='49'
              height='48'
              viewBox='0 0 49 48'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clipPath='url(#clip0_9392_51688)'>
                <path
                  className={styles.arrPath}
                  d='M24.9277 48C11.6729 48 0.927734 37.2548 0.927734 24C0.927734 10.7452 11.6729 0 24.9277 0C38.1826 0 48.9277 10.7452 48.9277 24C48.9277 37.2548 38.1826 48 24.9277 48Z'
                  fill='black'
                  // fillOpacity='0.3'
                />
                <path
                  d='M23.9277 29L28.9277 24L23.9277 19'
                  stroke='white'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  fillOpacity={1}
                />
              </g>
              <defs>
                <clipPath id='clip0_9392_51688'>
                  <rect width='48' height='48' fill='white' transform='matrix(-1 0 0 1 48.9277 0)' />
                </clipPath>
              </defs>
            </svg>
          </div>
        )}
        <div className={styles.imgContainer}>
          <Gallery
            options={{
              arrowPrev: true,
              arrowNext: true,
              arrowPrevSVG: ReactDOMServer.renderToString(L_ARROW),
              arrowNextSVG: ReactDOMServer.renderToString(R_ARROW),
              // secondaryZoomLevel: 1,
              bgOpacity: 1,
              closeSVG: false,
              mainClass: styles.productMasterGallery,
              preload: [1, 1],
              showHideAnimationType: 'zoom',
              getViewportSizeFn: () => {
                return {
                  x: window.innerWidth,
                  y: document.documentElement.clientHeight - 100,
                };
              },
              paddingFn: (viewportSize) => {
                if (viewportSize.x <= 1440) return { top: 32, bottom: 32 };
                if (viewportSize.x <= 1920) return { top: 48, bottom: 48 };
                else return { top: 64, bottom: 64 };
              },
            }}
            uiElements={[
              {
                name: 'bulletsIndicator',
                className: 'pswp__bullets-indicator',
                appendTo: 'wrapper',
                onInit: (el, pswp) => {
                  const dotsELement = [];
                  pswp.dotsELement = dotsELement;
                  const renderCustomElement = () => {
                    // 获取父元素
                    const paginationPSWP = document.createElement('div');
                    paginationPSWP.className = styles.paginationPSWP;

                    const paginationList = document.createElement('div');
                    paginationList.className = styles.paginationList;

                    // 遍历 masterList.thumbList 并创建每个子元素
                    masterList.thumbList.forEach((item, index) => {
                      const dot = document.createElement('div');
                      dot.className = ClassNames([
                        styles.dot,
                        styles.b_dot,
                        index === pswp.currIndex ? styles.active : '',
                      ]);

                      // 添加点击事件
                      dot.onclick = () => {
                        pswp.goTo(index);
                      };

                      const img = document.createElement('img');
                      img.className = styles.thumb;
                      img.src = item?.url_s;
                      img.alt = '';

                      dotsELement.push(dot);
                      dot.appendChild(img);
                      paginationList.appendChild(dot);
                    });

                    if (masterList.showMoreDot) {
                      const lastDot = document.createElement('div');
                      lastDot.className = ClassNames([
                        styles.dot,
                        styles.b_dot,
                        styles.b_lastDot,
                        pswp.currIndex >= SHOW_THUMB_MAX - 1 ? styles.active : '',
                      ]);

                      const img = document.createElement('img');
                      img.className = styles.thumb;
                      img.src =
                        masterList.remainThumbList[pswp.currIndex - SHOW_THUMB_MAX + 1]?.url_s ??
                        masterList.masterList[SHOW_THUMB_MAX - 1]?.url_s;
                      img.alt = '';

                      const span = document.createElement('span');
                      span.innerHTML = samllMasterText;

                      lastDot.appendChild(img);
                      lastDot.appendChild(span);
                      dotsELement.push(lastDot);
                      paginationList.appendChild(lastDot);
                    }

                    paginationPSWP.appendChild(paginationList);
                    el.appendChild(paginationPSWP);

                    const closeBtn = ReactDOMServer.renderToString(CLOSE_ICON);

                    const closeBtnElement = document.createElement('div');
                    closeBtnElement.innerHTML = closeBtn;
                    // closeBtnElement.appendChild(closeBtn);
                    closeBtnElement.className = styles.closeBtn;

                    closeBtnElement.onclick = () => {
                      ProudctPoint.productPageImages({
                        category: 'pc_product_image_pop',
                        action: 'click_close',
                        data: {
                          ...curSelectCommodity,
                          url_key,
                        },
                      });
                      pswp.close();
                    };

                    el.appendChild(closeBtnElement);
                  };

                  const resigterEvent = () => {
                    // 给每个 dot 添加点击事件
                    dotsELement.forEach((item, index) => {
                      item.onclick = () => {
                        ProudctPoint.productPageImages({
                          category: 'pc_product_image_pop',
                          action: 'click_thumbnail_pop',
                          data: {
                            ...curSelectCommodity,
                            url_key,
                            imageIndex: index + 1,
                          },
                        });
                        pswp.goTo(index);
                        splideRef.current.splide.go(index);
                      };
                    });

                    // 监听 pswp 的 change 事件 ，更换当前激活的 dot 图片
                    pswp.on('change', () => {
                      splideRef.current.splide.go(pswp.currIndex);
                      dotsELement.forEach((item, index) => {
                        if (pswp.currIndex > SHOW_THUMB_MAX - 1 && index >= SHOW_THUMB_MAX - 1) {
                          // 这是大于SHOW_THUMB_MAX的情况
                          item.classList.add(styles.active);
                          item.children[0].src =
                            masterList.remainThumbList[pswp.currIndex - SHOW_THUMB_MAX + 1]?.url_s ??
                            masterList.masterList[SHOW_THUMB_MAX - 1]?.url_s;
                        } else if (index === pswp.currIndex) {
                          item.classList.add(styles.active);
                        } else {
                          item.children[0].src = masterList.masterList[index]?.url_s;
                          item.classList.remove(styles.active);
                        }
                      });

                      if (masterList.showMoreDot) {
                        let lastDotText = '';
                        if (pswp.currIndex > SHOW_THUMB_MAX - 1)
                          lastDotText = `+${masterList.masterList?.length - pswp.currIndex}`;
                        else lastDotText = `+${masterList.masterList?.length - masterList.thumbList.length}`;
                        dotsELement[dotsELement.length - 1].children[1].innerHTML = lastDotText;
                      }
                    });

                    pswp.on('close', () => {
                      isOpen = false;
                      toggleGlobalScroll(false);
                    });

                    pswp.on('contentActivate', ({ content }) => {
                      if (!content.isExpose) {
                        ProudctPoint.productPageImages({
                          category: 'pc_product_image_pop',
                          action: 'expose_image_pop',
                          data: {
                            ...curSelectCommodity,
                            url_key,
                            imageIndex: content.index + 1,
                          },
                        });
                        content.isExpose = true;
                      }
                    });

                    pswp.on('imageSizeChange', ({ width, slide }) => {
                      if (width === 2000 && !slide?.isEnlarge) {
                        ProudctPoint.productPageImages({
                          category: 'pc_product_image_pop',
                          action: 'enlarge_image',
                          data: {
                            ...curSelectCommodity,
                            url_key,
                          },
                        });
                        slide.isEnlarge = true;
                      }
                    });

                    pswp.on('contentAppend', ({ content }) => {
                      content.placeholder.element.style.display = 'none';
                    });

                    pswp.addFilter('isKeepingPlaceholder', () => {
                      return true;
                    });

                    // close、openingAnimationStart、destroy事件的操作是为了兼容主图存在透明度内容在展开时的动画效果
                    pswp.on('openingAnimationStart', () => {
                      pswp.currSlide.data.element.style.opacity = '0';
                      setTimeout(() => {
                        pswp.currSlide.data.element.style.opacity = '1';
                      }, 1000);
                    });

                    pswp.on('close', () => {
                      pswp.currSlide.data.element.style.opacity = '0';
                    });

                    pswp.on('destroy', () => {
                      pswp.currSlide.data.element.style.opacity = '1';
                    });
                  };

                  renderCustomElement(); // 渲染分页器
                  resigterEvent(); // 注册事件
                },
              },
            ]}
            onOpen={() => {
              isOpen = true;
              toggleGlobalScroll(true);
            }}
          >
            <Splide
              ref={(ref) => (splideRef.current = ref)}
              options={{
                pagination: false,
                arrows: false,
                type: 'fade',
                rewind: true,
                autoHeight: true,
                lazyLoad: 'nearby',
                preloadPages: 2,
              }}
              onMove={(splide, newIndex) => {
                if (!EXPOSE_IMAGE.has(newIndex) && !isOpen) {
                  ProudctPoint.productPageImages({
                    action: 'expose_image',
                    data: {
                      ...curSelectCommodity,
                      url_key,
                      imageIndex: newIndex + 1,
                    },
                  });
                  EXPOSE_IMAGE.set(newIndex, true);
                }
                const preLoadImg = new window.Image();
                preLoadImg.src = masterList.masterList[newIndex]?.urlL;
                setActiveIndex(newIndex);
              }}
            >
              {masterList.masterList.map((item, index) => {
                return (
                  <SplideSlide key={item.id}>
                    <Item original={item?.urlL} thumbnail={item?.url_m} width={2000} height={2000}>
                      {({ ref, open }) => {
                        let _open = masterList?.isCanZoom ? open : () => {};
                        return (
                          <img
                            className={styles.master}
                            data-iscanzoom={masterList?.isCanZoom}
                            ref={ref}
                            onClick={() => {
                              ProudctPoint.productPageImages({
                                action: 'click_image',
                                data: {
                                  ...curSelectCommodity,
                                  imageIndex: index + 1,
                                  url_key,
                                },
                              });
                              _open?.();
                            }}
                            data-splide-lazy={item?.url_m}
                            alt=''
                            style={{
                              transform: scaleProductMaster && showMediaLogo ? 'scale(0.9)' : 'unset',
                            }}
                          />
                        );
                      }}
                    </Item>
                  </SplideSlide>
                );
              })}
            </Splide>
          </Gallery>
        </div>
        <div className={styles.videoContainer}>
          <Splide
            ref={(ref) => (videoSplideRef.current = ref)}
            options={{
              pagination: false,
              arrows: false,
              type: 'fade',
              rewind: true,
            }}
            onMove={(splide, newIndex, preIndex) => {
              handleVideo('video_move', { splide, newIndex, preIndex });
              setActiveIndex(newIndex);
            }}
          >
            {mainVideoList.map((item, curIndex) => {
              return (
                <SplideSlide key={`${item.id}_${curSelectCommodityId}`}>
                  <div className={styles.videoItem}>
                    <div
                      className={styles.playWrap}
                      style={{ backgroundImage: `url('${item.coverLink}')` }}
                      onClick={() => handleVideo('video_play', { curIndex })}
                    >
                      <svg
                        className={styles.playIcon}
                        width='80'
                        height='80'
                        viewBox='0 0 80 80'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M32 40V27.2546C32 24.218 35.4323 22.4517 37.9033 24.2166L46 30L55.7469 36.9621C57.8314 38.451 57.8314 41.549 55.7469 43.0379L46 50L37.9033 55.7834C35.4323 57.5483 32 55.782 32 52.7454V40Z'
                          fill='white'
                        />
                      </svg>
                      <div className={styles.loadingIcon}>
                        <LoadingOutlined style={{ fontSize: '32px' }} />
                      </div>
                    </div>
                    <video
                      data-innername={item?.videoInnerName}
                      id='mainVideo'
                      controls
                      data-mastersrc={item.videoLink}
                      poster={item.coverLink}
                    />
                  </div>
                </SplideSlide>
              );
            })}
          </Splide>
        </div>
      </div>
      <div className={styles.paginationWrap}>
        {showThumb && (
          <div className={styles.paginationList}>
            {masterList.thumbList.map((item, index) => {
              return (
                <div
                  key={`thum-${index}`}
                  onMouseEnter={() => {
                    ProudctPoint.productPageImages({
                      action: 'hover_thumbnail',
                      data: {
                        ...curSelectCommodity,
                        imageIndex: index + 1,
                        url_key,
                      },
                    });
                  }}
                  onClick={() => {
                    handleVideo('video_stop_all');
                    if (curstate !== 'img') {
                      handleSmallVideo('samllVideo_init');
                      setCurState('img');
                    }
                    setActiveIndex(index);
                    ProudctPoint.productPageImages({
                      action: 'click_thumbnail',
                      data: {
                        ...curSelectCommodity,
                        imageIndex: index + 1,
                        url_key,
                      },
                    });
                    splideRef.current.splide.go(index);
                  }}
                  className={ClassNames([styles.dot, index === activeIndex && curstate === 'img' ? styles.active : ''])}
                >
                  <img className={styles.thumb} src={item?.url_s} alt='' />
                </div>
              );
            })}
            {masterList.showMoreDot && (
              <div
                onClick={() => {
                  setCurState('img');
                  splideRef.current.splide.go(SHOW_THUMB_MAX - 1);
                }}
                className={ClassNames([
                  styles.dot,
                  styles.lastDot,
                  activeIndex >= SHOW_THUMB_MAX - 1 && curstate === 'img' ? styles.active : '',
                ])}
              >
                <img
                  className={styles.thumb}
                  src={
                    masterList.remainThumbList[activeIndex - SHOW_THUMB_MAX + 1]?.url_s ??
                    masterList.masterList[SHOW_THUMB_MAX - 1]?.url_s
                  }
                  alt=''
                />
                <span>{samllMasterText}</span>
              </div>
            )}
          </div>
        )}
        {mainVideoList?.length > 0 && (
          <div className={styles.videoWrap}>
            <div className={styles.line} />
            <div
              className={styles.videoBtn}
              data-active={curstate === 'video'}
              onClick={() => {
                setCurState('video');
                setActiveIndex(0);
                ProudctPoint.productPageImages({
                  action: 'click_video_button',
                  data: curSelectCommodity,
                });
                // 记录的一号坑位曝光
                if (!EXPOSE_VIDEO.has(mainVideoList?.[0]?.id)) {
                  ProudctPoint.productPageImages({
                    action: 'video_expose',
                    data: {
                      ...curSelectCommodity,
                      videoInnerName: mainVideoList?.[0]?.videoInnerName,
                      url_key,
                    },
                  });
                  EXPOSE_VIDEO.set(mainVideoList?.[0]?.id, true);
                }
                handleSmallVideo('smallVideo_play_mainVideo');
              }}
            >
              <Splide
                ref={(ref) => (smallVideoSplideRef.current = ref)}
                options={{
                  type: 'fade',
                  rewind: true,
                  arrows: false,
                  pagination: false,
                }}
                onMove={(splide, newIndex, preIndex) => {
                  if (curstate === 'img') {
                    handleSmallVideo('smallVideo_move', { splide, newIndex, preIndex });
                  }
                }}
                className={styles.videoPagination}
              >
                {mainVideoList.map((item) => {
                  return (
                    <SplideSlide key={item.id}>
                      <video
                        id='smallVideo'
                        muted
                        classList={styles.pagination_video}
                        data-masterSrc={item?.videoPreviewLinkPc}
                        poster={item?.coverPreviewLinkPc}
                      />
                    </SplideSlide>
                  );
                })}
              </Splide>
              <span>{smallVideoText}</span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
});

export default ProductMaster;
